import { render } from "./AnnuitantInfo.vue?vue&type=template&id=43eb6b47"
import script from "./AnnuitantInfo.vue?vue&type=script&lang=js"
export * from "./AnnuitantInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__